import { HCreteFileDataToServer } from "@rf-l1/file/helpers/create-file-data-to-server";
import { HGetValueFromArray } from "@rf-helper/get-value-from-array";
import HCheckArray from "@rf-helper/check-have-value";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareValidationToServer = (res: IPropertyForm) => {
  const bodyData: I_BodyData = {
    validation_date: {
      trust: res.date_file_definitive_trustee,
      no_objection: res.date_no_objection_issuance,
      legal_status: res.date_file_legal_status,
      environment: res.date_file_environment,
      building_license: res.date_construction_license,
      previous_mitur: res.date_file_previous_mitur,
      final_confotur: res.date_file_definitive_confotur,
      // temporal_legal_status: res.date_file_legal_status,
      acoprovi: res.date_file_acoprovi,
      aprocovici: res.date_file_aprocovici,
      land_movement: res.date_file_evidence_earth_movement,
      commercial_register: res.date_file_commercial_register,
      deposit_at_town_hall: res.date_deposit_town_hall,
      land_purchase: res.date_file_purchase_sale_land
    },
    validation_file: {
      acoprovi: getFile(res.file_acoprovi),
      aprocovici: getFile(res.file_aprocovici),
      building_license: getFile(res.file_construction_license),
      credit_bureau: getFile(res.file_credit_bureau),
      commercial_register: getFile(res.file_commercial_register),
      company_rnc: getFile(res.file_rnc_construction),
      construction_company_resume: getFile(res.file_construction_cv),
      deposit_at_town_hall: getFile(res.file_deposit_in_town_hall),
      environment: getFile(res.file_environment),
      final_confotur: getFile(res.file_definitive_confotur),
      land_movement: getFile(res.file_evidence_earth_movement),
      land_purchase: getFile(res.file_purchase_sale_land),
      land_transfer_tax: getFile(res.file_tax_receipt),
      master_plan: getFile(res.file_master_plan),
      no_objection: getFile(res.file_no_objection_from_town_hall),
      previous_mitur: getFile(res.file_previous_mitur),
      // temporal_legal_status: getFile(res.file_legal_status),
      trust_transferred_title: getFile(res.file_title_transfer_trustee),
      trust_transferred_title_builder: getFile(res.file_title_transfer_trustee),
      legal_status: getFile(res.file_legal_status),
      enlarged_due_diligence: getFile(res.file_due_diligence),
      trust: getFile(res.file_definitive_trustee),
      company_assembly_act: getFile(res.file_assembly_minutes)
    },
    trust_status: HGetValueFromArray(res.trust_has_trustee, "value"),
    trust_entity_id: HGetValueFromArray(res.trust_name_trustee, "id"),
    trust_email: res.trust_email_trustee,
    trust_rnc: res.trust_rnc_trustee,
    trust_officer_name: res.trust_name_official_trustee,
    project_company_name: res.name_construction_company,
    project_company_rnc: res.rnc_construction,
    has_trust_meeting: HGetValueFromArray(res.trust_has_meeting_trustee, "id"),
    meeting_trust_entity_id: HGetValueFromArray(
      res.trust_entity_has_meeting_trustee,
      "id"
    ),

    meeting_officer_name: res.trust_oficial_name_meeting_trustee,
    meeting_notes: res.trust_notes_trustee,
    trust_meeting_date: res.trust_date_meeting_trustee,
    estimated_trust_formation_date: res.trust_estimated_constitution_date,
    is_legal_status_definitive: 0,
    has_confotur: HGetValueFromArray(res.has_confotur, "id"),
    has_transferred_title_builder: 0
  };
  return bodyData;
};
export default prepareValidationToServer;

enum keys {
  DOCUMENT_TRUST = "trust",
  DOCUMENT_NO_OBJECTION = "no_objection",
  DOCUMENT_LEGAL_STATUS = "legal_status",
  DOCUMENT_LAND_PURCHASE = "land_purchase",
  DOCUMENT_ENVIRONMENT = "environment",
  DOCUMENT_BUILDING_LICENSE = "building_license",
  DOCUMENT_PREVIOUS_MITUR = "previous_mitur",
  DOCUMENT_FINAL_CONFOTUR = "final_confotur",
  DOCUMENT_APROCOVICI = "aprocovici",
  DOCUMENT_COMPANY_ASSEMBLY_ACT = "company_assembly_act",
  DOCUMENT_ENLARGED_DUE_DILIGENCE = "enlarged_due_diligence",
  DOCUMENT_CREDIT_BUREAU = "credit_bureau",
  DOCUMENT_COMPANY_RNC = "company_rnc",
  DOCUMENT_MASTER_PLAN = "master_plan",
  DOCUMENT_COMMERCIAL_REGISTER = "commercial_register",
  DOCUMENT_TRUST_TRANSFERRED_TITLE = "trust_transferred_title",
  DOCUMENT_TRUST_TRANSFERRED_TITLE_BUILDER = "trust_transferred_title_builder",
  DOCUMENT_LAND_TRANSFER_TAX = "land_transfer_tax",
  DOCUMENT_DEPOSIT_AT_TOWN_HALL = "deposit_at_town_hall",
  DOCUMENT_LAND_MOVEMENT = "land_movement",
  DOCUMENT_CONSTRUCTION_COMPANY_RESUME = "construction_company_resume",
  // DOCUMENT_TEMPORAL_LEGAL_STATUS = "temporal_legal_status",
  DOCUMENT_ACOPROVI = "acoprovi"
}

interface I_BodyData {
  validation_date?: {
    [keys.DOCUMENT_TRUST]: string;
    [keys.DOCUMENT_NO_OBJECTION]: string;
    [keys.DOCUMENT_LEGAL_STATUS]: string;
    [keys.DOCUMENT_ENVIRONMENT]: string;
    [keys.DOCUMENT_BUILDING_LICENSE]: string;
    [keys.DOCUMENT_PREVIOUS_MITUR]: string;
    [keys.DOCUMENT_FINAL_CONFOTUR]: string;
    [keys.DOCUMENT_COMMERCIAL_REGISTER]: string;
    [keys.DOCUMENT_APROCOVICI]: string;
    [keys.DOCUMENT_DEPOSIT_AT_TOWN_HALL]: string;
    [keys.DOCUMENT_LAND_MOVEMENT]: string;
    [keys.DOCUMENT_LAND_PURCHASE]: string;
    // [keys.DOCUMENT_TEMPORAL_LEGAL_STATUS]: string;
    [keys.DOCUMENT_ACOPROVI]: string;
  };
  validation_file?: {
    [keys.DOCUMENT_NO_OBJECTION]: File | string | null;
    [keys.DOCUMENT_LEGAL_STATUS]: File | string | null;
    [keys.DOCUMENT_LAND_PURCHASE]: File | string | null;
    [keys.DOCUMENT_ENVIRONMENT]: File | string | null;
    [keys.DOCUMENT_BUILDING_LICENSE]: File | string | null;
    [keys.DOCUMENT_PREVIOUS_MITUR]: File | string | null;
    [keys.DOCUMENT_FINAL_CONFOTUR]: File | string | null;
    [keys.DOCUMENT_APROCOVICI]: File | string | null;
    [keys.DOCUMENT_ENLARGED_DUE_DILIGENCE]: File | string | null;
    [keys.DOCUMENT_CREDIT_BUREAU]: File | string | null;
    [keys.DOCUMENT_COMPANY_RNC]: File | string | null;
    [keys.DOCUMENT_MASTER_PLAN]: File | string | null;
    [keys.DOCUMENT_COMMERCIAL_REGISTER]: File | string | null;
    [keys.DOCUMENT_TRUST_TRANSFERRED_TITLE]: File | string | null;
    [keys.DOCUMENT_TRUST_TRANSFERRED_TITLE_BUILDER]: File | string | null;
    [keys.DOCUMENT_LAND_TRANSFER_TAX]: File | string | null;
    [keys.DOCUMENT_DEPOSIT_AT_TOWN_HALL]: File | string | null;
    [keys.DOCUMENT_LAND_MOVEMENT]: File | string | null;
    [keys.DOCUMENT_CONSTRUCTION_COMPANY_RESUME]: File | string | null;
    // [keys.DOCUMENT_TEMPORAL_LEGAL_STATUS]: File | string | null;
    [keys.DOCUMENT_ACOPROVI]: File | string | null;
    [keys.DOCUMENT_TRUST]: File | string | null;
    [keys.DOCUMENT_COMPANY_ASSEMBLY_ACT]: File | string | null;
  };
  trust_status: null | "no" | "pending" | "yes";
  trust_entity_id: number;
  has_transferred_title_builder: null | number;
  trust_email: null | string;
  trust_officer_name: null | string;
  trust_rnc: null | string;
  project_company_name: null | string;
  project_company_rnc: null | string;
  has_trust_meeting: null | number;
  meeting_trust_entity_id: null | number;
  meeting_officer_name: null | string;
  meeting_notes: null | string;
  trust_meeting_date: null | string;
  is_legal_status_definitive: null | number;
  has_confotur: null | number;
  estimated_trust_formation_date: null | string;
}

const getFile = (c: any) => {
  if (HCheckArray(c)) {
    return HCreteFileDataToServer(c[0]);
  } else {
    return null;
  }
};
